import { createContext } from 'react';

export const NonprofitOnboardingPaymentFlowContext = createContext<
  | null
  | (Record<string, unknown> & {
      send: (event: unknown) => void;
      isTransitionAllowed: (event: string) => boolean;
    })
>(null);
